import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { questions } from '../data/faq';
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="bg-stone-100 py-20" aria-labelledby="faq-title" data-id="element-65" data-mp="1he2wzy8t5mf4">
      <div className="mx-auto max-w-3xl px-4" data-id="element-66" data-mp="1cfjd03drykpe">
        <h2 id="faq-title" className="text-balance text-center text-3xl font-extrabold text-emerald-950 md:text-4xl" data-id="element-67" data-mp="1ccndiama3nyu">
          Preguntas frecuentes
        </h2>

        <div className="mt-10 space-y-3" data-id="element-68" data-mp="254gsjyqlq3eg">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} className={`overflow-hidden rounded-lg border bg-white transition-colors duration-200 ease-out ${isOpen ? 'border-emerald-700' : 'border-stone-200'}`} data-id="element-69" data-mp="1v5hl2jhkodt1" data-mpi={index}>
                <h3 data-id="element-70" data-mp="jo9g9x30kvoc">
                  <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left font-sans font-bold text-emerald-950 focus:outline-none focus-visible:ring-4 focus-visible:ring-amber-300/60 sm:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-71" data-mp="jrxayzk73o4n">
                    <span data-id="element-72" data-mp="1fqgkpdzijy2z">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-stone-500 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-73" data-mp="11wyytmjcu99s" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-74" data-mp="wxmh1g7cbse2">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-75" data-mp="iymr8583d7gb">
                      <p className="border-t border-stone-100 px-5 py-4 leading-relaxed text-stone-800 sm:px-6" data-id="element-76" data-mp="2kvetuw3li2kv">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}